// extracted by mini-css-extract-plugin
export default {"container":"Top_container__FWiqW","side":"Top_side__ipYxs","left":"Top_left__rVPfu","djiLogo":"Top_djiLogo__32eTg","mavlinkLogo":"Top_mavlinkLogo__nVJWW"};